<template>
    <div class="head">
        <div class="left-timer">{{ timer }}</div>
        <div class="head-title">{{ title }}</div>
        <div class="large" @click="screen">
            <img src="../../assets/template/screen.png" alt="">
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import screenfull from 'screenfull'

export default {
    name: 'template4.temhead4',
    props: {
        title: {
            type: String,
            default: '餐饮业招商加盟大屏'
        }
    },
    data() {
        return {
            timer: ''
        }
    },
    mounted() {
        this.gettime()
    },
    methods: {
        gettime() {
            this.timer = moment().format('yyyy年MM月DD日  HH:mm:ss');
            setTimeout(() => {
                this.gettime()
            }, 100);
        },
        screen() {
            // 如果不允许进入全屏，发出不允许提示
            if (!screenfull.enabled) {
                // this.$message("您的浏览器不能全屏")
                return false
            }
            screenfull.toggle()
            // this.$message.success("全屏啦")
        },
    }
}
</script>

<style lang="scss" scoped>
.head {
    width: 1920px;
    height: 99px;
    background: url(../../assets/template4/header.png) no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    z-index: 401;
    pointer-events: none;
    margin-bottom: 24px;
    // pointer-events: auto;

    .head-title {
        line-height: 37px;
        // text-shadow: 0px 1px 6px rgba(0,0,0,0.48);
        font-style: italic;
        height: fit-content;
        padding: 0 4px;
        margin-top: -10px;
        margin-left: -38px;
        font-family: PangMenZhengDao;
        font-weight: 400;
        font-size: 42px;
        color: #37C2F4;
        text-shadow: 0px 20px 14px rgba(255, 255, 255, 0.61);
        background: linear-gradient(0deg, #FFFFFF 0%, #A0F3FF 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;

    }

    .left-timer {
        font-family: Source Han Sans CN;
        font-weight: 400;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 15px;
        font-style: italic;
        position: absolute;
        left: 64px;
        top: 50px;
        text-shadow: 0 0 10px rgba(41, 81, 202, .8), 0 0 10px rgba(41, 81, 202, .8), 0 0 10px rgba(41, 81, 202, .8);
    }

    .large {
        position: absolute;
        right: 64px;
        top: 42px;
        cursor: pointer;
        pointer-events: auto;

        img {
            width: 46px;
            height: 46px;
        }
    }
}
</style>